import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const PlayerService = {}


PlayerService.getPlayer = function (params) {
	 let {page, searchPlayer} = params;
	 let offset = (page-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-player',
		method: 'get',
        params: {
            'offset' : offset,
			searchPlayer
        }
	})
};

PlayerService.getPlayerWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-player/${id}`,
		method: 'get',

	})
};

PlayerService.getPlayerTracker = function (data) {
	 let {id, page} = data;

	let offset = (page-1)*10;
   return fetch({
	   url: API_BASE_URL+`/v1/admin/tracker/${id}`,
	   method: 'get',
	   params: {
		   'offset' : offset
	   }
   })
};

PlayerService.getPlayerGroup = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/player-group/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};
PlayerService.getPlayerInjuryTracker = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/injury-tracker/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};
PlayerService.getPlayerSession = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/player-session/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

PlayerService.getPlayerCoach = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/player-coach/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};


export default PlayerService;